import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import styles from './index.sass';

class Select extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
    style: React.PropTypes.object,
    value: React.PropTypes.string,
    onChange: React.PropTypes.func
  };

  static defaultProps = {
    style: {}
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnChange(e) {
    if(this.props.onChange) {
      this.props.onChange(e.target.value);
    }
  }

  render() {
    let className = styles.select;
    if(this.props.className) {
      className += (' ' + this.props.className);
    }

    return (
      <div className={className} style={this.props.style}>
        <select className={styles.input} onChange={this.handleOnChange.bind(this)} value={this.props.value}>
          {this.props.children}
        </select>
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// banquet/components/Select/index.js